import { Paragraph } from '@deckee/deck-hand';
import React, { useEffect } from 'react';
import {
  ROUTE_CHANGE_EMAIL,
  ROUTE_SETTINGS,
} from '../../../services/route/route-names';
import { transitionToNextRoute } from '../../../services/route/route-navigation';
import BasicDrawerLayout from '../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import { LayoutBody } from '../../layouts/components/LayoutBody/LayoutBody';
import { trackChangeEmailEvent } from './change-email-events';
import DrawerFlowCard from '../../shared/DrawerFlowCard/DrawerFlowCard';
import DrawerFlowSuccessMessage from '../../shared/DrawerFlowCard/components/DrawerFlowSuccessMessage';

const ChangeEmailReauthWaitingPage = () => {
  useEffect(() => {
    trackChangeEmailEvent('view', { step: 'reauth waiting' });
  }, []);

  return (
    <BasicDrawerLayout
      heading="Check your current email"
      onBack={() => {
        trackChangeEmailEvent('back', { step: 'reauth waiting' });
        transitionToNextRoute(ROUTE_CHANGE_EMAIL);
      }}
      onClose={() => {
        trackChangeEmailEvent('close', { step: 'reauth waiting' });
        transitionToNextRoute(ROUTE_SETTINGS);
      }}
    >
      <LayoutBody>
        <DrawerFlowCard heading="Step 1 of 3">
          <DrawerFlowSuccessMessage>
            We sent a verification email to your address. Open that email and
            tap the link to complete the process.
          </DrawerFlowSuccessMessage>
          <Paragraph fontSize="1" color="darkergrey">
            Please note, if you have already created a separate DECKEE account
            with your new email address, you will need to contact support for
            further assistance.
          </Paragraph>
        </DrawerFlowCard>
      </LayoutBody>
    </BasicDrawerLayout>
  );
};

export default ChangeEmailReauthWaitingPage;
